import { createUseStyles } from 'react-jss';

import { ViboTheme } from 'types/theme';

const useStyles = createUseStyles((theme: ViboTheme) => ({
  signInPolicyDescription: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    color: theme.palette.text.hint,
    fontSize: '9px',
    lineHeight: '12.6px',
    margin: '13px 0 0 0',

    '@media screen and (min-width: 1441px)': {
      margin: '15px 0 0 0',
      fontSize: '12px',
      lineHeight: '16.8px',
    },
  },

  headInfo: {
    margin: '0 0 14px 0',
    fontSize: '11px',
    lineHeight: '16.55px',
    maxWidth: '281px',

    '& a': {
      color: theme.palette.primary.main,
    },

    '@media screen and (min-width: 1441px)': {
      fontSize: '14px',
      lineHeight: '21.07px',
      margin: '0 0 10px 0',
    },
  },
}));

export default useStyles;
